import { Roles } from "../constants/roles";
import { FormBase } from "../util/form-base-form";

export class HomeRankingProductTabsForm extends FormBase {
    private readonly root: HTMLElement;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
    }

    public static getRoots(root: ParentNode | Document | HTMLElement = document): HTMLElement[] {
        const form = new HomeRankingProductTabsForm(root instanceof HTMLElement ? root : document.body);
        const roots: HTMLElement[] = [];
        if (root instanceof HTMLElement && root.matches(`[data-role="${Roles.HOME_RANKING_PRODUCT_TABS}"]`)) {
            roots.push(root);
        }
        form.queryElements(root, `[data-role="${Roles.HOME_RANKING_PRODUCT_TABS}"]`, HTMLElement).forEach((node) => {
            if (!roots.includes(node)) {
                roots.push(node);
            }
        });
        return roots;
    }

    public getRoot(): HTMLElement {
        return this.root;
    }

    public isInitialized(): boolean {
        return this.root.dataset.homeRankingProductTabsInit === "1";
    }

    public markInitialized(): void {
        this.root.dataset.homeRankingProductTabsInit = "1";
    }

    public getInitialParentCategoryId(): string | null {
        const raw = (this.root.dataset.initialParentCategoryId || "").trim();
        return raw !== "" ? raw : null;
    }

    public getTabs(): HTMLElement[] {
        return this.queryElements(
            this.root,
            `[data-role="${Roles.HOME_RANKING_PRODUCT_TAB}"][data-parent-category-id]`,
            HTMLElement,
        );
    }

    public getPanels(): HTMLElement[] {
        return this.queryElements(
            this.root,
            `[data-role="${Roles.HOME_RANKING_PRODUCT_PANEL}"][data-parent-category-id]`,
            HTMLElement,
        );
    }
}
